import { render, staticRenderFns } from "./DetailTableItem.vue?vue&type=template&id=da057c44&scoped=true"
import script from "./DetailTableItem.vue?vue&type=script&lang=js"
export * from "./DetailTableItem.vue?vue&type=script&lang=js"
import style0 from "./DetailTableItem.vue?vue&type=style&index=0&id=da057c44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da057c44",
  null
  
)

export default component.exports